import styled from 'styled-components';
import { media } from '@prisjakt/ui-base';

export const Main = styled.section`
  min-height: calc(100vh - 390px);

  ${media.mediumUp`
    display: flex;
    flex-direction: row;

    @supports (display: grid) {
      display: grid;
      grid-template-columns: auto 1fr; 
    }
  `}
`;

export const Content = styled.div`
  width: 100%;
`;
